import React from 'react';

const ProductCard = ({ product }) => {
    console.log(product);
    return (
        <div style={cardStyles.card}>
            {/* Thumbnail Image */}
            <img src={product.thumbnail} alt={product.product_name} style={cardStyles.thumbnail} />

            <h3 style={cardStyles.productName}>{product.product_name}</h3>
            <p style={cardStyles.price}>Price: {product.price}</p>
            <p style={cardStyles.source}>Platform: {product.source}</p>
            <a href={product.link} target="_blank" rel="noopener noreferrer" style={cardStyles.button}>
                Buy Now
            </a>
        </div>
    );
};

const cardStyles = {
    card: {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        padding: '16px',
        borderRadius: '12px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        marginBottom: '16px',
        width: '100%',
        maxWidth: '300px',
        transition: 'transform 0.2s ease',
    },
    thumbnail: {
        width: '50%',
        height: 'auto',
        borderRadius: '8px',
        marginBottom: '12px',
        objectFit: 'cover',
        display: 'block',
        margin: 'auto'
    },
    productName: {
        fontSize: '18px',
        marginBottom: '8px',
    },
    price: {
        fontSize: '16px',
        marginBottom: '8px',
    },
    source: {
        fontSize: '14px',
        marginBottom: '16px',
        color: 'gray',
    },
    button: {
        backgroundColor: 'rgba(0, 132, 255, 0.7)',
        color: 'white',
        padding: '8px 16px',
        borderRadius: '8px',
        textDecoration: 'none',
        display: 'inline-block',
        fontWeight: 'bold',
    },
};

export default ProductCard;
